import React from 'react';
import LoadingPlaceholder from '../../../../../muiComponents/LoadingPlaceholder';

const LoadingPanel = () => {
    return (
        <div className='flex-column height100perc'>
            <LoadingPlaceholder variant='text' height={120} width={'100%'} />
            <LoadingPlaceholder variant='text' height={120} width={'100%'} />
            <LoadingPlaceholder variant='text' height={120} width={'100%'} />
            <LoadingPlaceholder variant='text' height={120} width={'100%'} />
            <LoadingPlaceholder variant='text' height={120} width={'100%'} />
            <LoadingPlaceholder variant='text' height={120} width={'100%'} />
        </div>
    );
};

export default LoadingPanel;
